import { render } from "./OpportunityIdView.vue?vue&type=template&id=33a6cfdc"
import script from "./OpportunityIdView.vue?vue&type=script&lang=js"
export * from "./OpportunityIdView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__